import { DB2CopySource } from './../../../pipeline/copysource/db2.copysource';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DB2CopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class DB2CopySourceAdapter extends CopySourceAdapter<DB2CopySource, Model.Db2Source> {
    protected override async _toResource(copySource: DB2CopySource): Promise<Model.Db2Source> {
        return this._toTabularResource(copySource, Metamodel.modelFor(DB2CopySource).name);
    }

    protected override async _toModel(resource: Model.Db2Source, copyActivity: CopyActivity): Promise<DB2CopySource> {
        return this._toTabularModel(resource, copyActivity, DB2CopySource.MODEL);
    }
}
